import React ,{useState,useEffect} from 'react';
import styled from 'styled-components';
import { useHistory } from "react-router-dom";
import MypagePWchange from '../pages/MypagePWchange';
import MypagePFchangeDtail from '../components/mypage/mypagesetDetail/MypagePFchangeDtail';
import MypagePfimgbasic from '../components/mypage/mypagesetDetail/MypagePfimgbasic';
import BottomModalVar2 from '../components/modal/Bottom_Modal_var2'
import TopModalbar from '../components/modal/TopModalbar'
import serverController from "../server/serverController";
import CenterModal from 'components/presenters/modal/CenterModal';
import { compressImage } from 'utils/utils.js';
import { UserInfoActions } from 'store/actionCreators';

// 하단 모달 창 리스트 
let data = [
    { text:"앨범에서 선택",color:"#4e4e4e",}, 
    { text:"카메라 촬영",color:"#4e4e4e", },
    { text:"기본 이미지",color:"#4e4e4e", }
]



export default function MypageProfileChange({match}) {
    const history = useHistory();

    const [screenIndex ,setScreenIndex] = useState(0);

    const [nickname ,setNickname] = useState("");
    const [purpose,setPurpose] = useState("");
    const [name ,setName] = useState("");
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [newPassword,setNewPassword] = useState("");
    const [newPasswordCheck,setNewPasswordCheck] = useState("");
    const [profileImg ,setProfileImg] = useState("default_profile_1.png");
    const [image ,setImage] = useState(null);
    const [ file,setFile] = useState(null);
    const [profilecheck ,setProfilecheck] = useState(null);

    const [modalShow,setModalShow] = useState(false);
    const [showModalTop, setShowModalTop] = useState(false);


    //Center Modal State
    const [initCenterModal, setInitCenterModal] = useState(false);
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState({});
    const [onModalComplete, setOnModalComplete] = useState(null);
    const [onModalCancel, setOnModalCancel] = useState(null);

    const init = () => {
        data[0].clickEvent = () =>{ document.getElementById("imagePicker").click(); setModalShow(false); };
        data[1].clickEvent = () =>{ document.getElementById("imagePicker").click(); setModalShow(false); };
        data[2].clickEvent = () =>{setModalShow(false); updateNext(1)}
   }
   init();

    const passwordSubmit =()=>{
        // updateNext(-2);
    }
   


    const updateNext = (index) =>{
        // 페이지 더 생성되면 숫자 늘려나가기
        if(screenIndex + index === -1 || screenIndex + index > 2)
            return;
        setScreenIndex(screenIndex + index);
    }


    //Init Center Modal State
    useEffect(()=>{
        if(initCenterModal === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList({})
            setOnModalComplete(null);
            setOnModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])

    // 회원정보 받아오기
    const [userinfo , setUserinfo] = useState({});
    const infoCallBacks = (jsonData) => {
        if(jsonData.success !== 1){
            alert('예기치 못한 오류가 발생하였습니다.');
            return;
        }
        setUserinfo(jsonData.data.user);
        setNickname(jsonData.data.user.nickname);
        setPurpose(jsonData.data.user.achievement_goal);
        setEmail(jsonData.data.user.email);
        setProfileImg(jsonData.data.user.profile_img);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        serverController.getServerData(`users/${match.params.id}`,infoCallBacks);
    },[]);

    
    const imageChange = async (e) =>{
   
        let reader = new FileReader();
        let file = e.target.files[0];
        let compressedFile = await compressImage(file, {maxSizeMB: 0.1,
                maxWidthOrHeight: 500,
                useWebWorker: true});
        reader.onloadend = (event) => {
            
            event.preventDefault();
            setImage(reader.result);
        }
        reader.readAsDataURL(compressedFile);

        setFile(compressedFile);
    }

    //수정된 회원 정보 보내기
    const callBack  = (res) =>{
        if(res.success === 1){
            let jsonData = res.data;
            let userData = jsonData['updated_item']['user'][0];
            let updatedState = {
                name: userData['nickname'],
                email: userData['email'],
                id:userData['no'],
                isLogin:true, 
                profile_img:userData['profile_img']
            }
            if(jsonData['updated_item']['user_info'])
            {
                let userInfoData = jsonData['updated_item']['user_info'][0];
                updatedState['achievement_goal'] = userInfoData['achievement_goal'];
            }
            UserInfoActions.updateUserState(updatedState);


            history.push(`/mypage`)
        }else {
            //{"success":0,"error":{"res_data":{"err_code":"DATA_ALREADY_EXISTS","detail_code":"NICKNAME_ALREADY_EXIST","msg":"nickname already exist"},"route":"PUT - /users/6379"}}

            if(res?.error?.res_data)
            {
                const errData = res.error.res_data;
                if(errData['detail_code'] === 'NICKNAME_ALREADY_EXIST')
                {
                    setCenterModalVisible(true);
                    setCenterModalDataList({description:"닉네임이 이미 존재합니다."});
                    setOnModalComplete(()=>()=>{
                        setInitCenterModal(true);
                    })
                }
                else
                {
                    setCenterModalVisible(true);
                    setCenterModalDataList({description:"예기치 못한 오류가 발생하였습니다."});
                    setOnModalComplete(()=>()=>{
                        setInitCenterModal(true);
                    })
                }
            }
            else
            {
                setCenterModalVisible(true);
                setCenterModalDataList({description:"예기치 못한 오류가 발생하였습니다."});
                setOnModalComplete(()=>()=>{
                    setInitCenterModal(true);
                })
            }
        }
    }
    const passwordSendCallBack =(res)=>{

        let serverData = {
            nickname : nickname,
            achievement_goal : purpose,
        };
        serverController.generalPutFetchController(`users/${match.params.id}`,JSON.stringify(serverData),callBack);
    }

    const insertProfileInfoToServer = async (imageName) => {
        if(password !== ""){
            let serverData = {
                nickname : nickname,
                achievement_goal : purpose,
                old_password : password,
                new_password : newPasswordCheck,
                profile_img : imageName ? imageName : profileImg 
            };
            await serverController.updateFilePutFetchController(`users/${match.params.id}/password`,JSON.stringify(serverData),passwordSendCallBack);
        }
        else {
            if(nickname === undefined || nickname === null || (typeof nickname === "string" && (nickname.length <2 || nickname.length > 10 )))
            {
                alert("닉네임은 2자 이상 20자 이하여야 합니다!");
            }
            else
            {
                let serverData = {
                    nickname : nickname,
                    achievement_goal : purpose,
                    profile_img : imageName ? imageName : profileImg 
                };
                await serverController.generalPutFetchController(`users/${match.params.id}`,JSON.stringify(serverData),callBack);
            }
        }
        
        isclick = false;
    } 

    /*--click block--*/
    var isclick = false;
    const dataSubmit= async ()=> {
        if(isclick)
            return;
        isclick = true;

        if(file){
            var formData = new FormData();      
            formData.append('file', file);
            formData.append('path',"user_profile_img/");
            serverController.updatefilePostFetchController(`file`,formData,function(data){ 
                var imagePathArray = [];
                data.data.upload_results.map((value)=>imagePathArray.push(value.file_name));
                insertProfileInfoToServer(imagePathArray[0]); 

            });
        }
        else
            insertProfileInfoToServer(null);

    }

    const clearProfileImage = () =>{
        setFile(null);
        setImage(null);
    }


    let renderPageController = () =>{
        switch(screenIndex){
            case 0 : return  <MypagePFchangeDtail 
                                image = {image}
                                updateNext={updateNext}
                                nickname={nickname}
                                setNickname={setNickname}
                                purpose={purpose}
                                setPurpose={setPurpose}
                                name={name}
                                setName={setName}
                                email={email}
                                profileImg={profileImg}
                                setEmail={setEmail}
                                dataSubmit={dataSubmit}
                                setModalShow={setModalShow}
                                profilecheck={profilecheck}
                            />
            case 1 : return  <MypagePfimgbasic 
                                clearProfileImage={clearProfileImage}
                                updateNext={updateNext}
                                setProfileImg={setProfileImg}
                                setProfilecheck={setProfilecheck}
                                setShowModalTop={setShowModalTop}
                            />
            case 2 : return  <MypagePWchange 
                                updateNext={updateNext}
                                password={password}
                                newPassword={newPassword}
                                newPasswordCheck={newPasswordCheck}
                                setPassword={setPassword}
                                setNewPassword={setNewPassword}
                                setNewPasswordCheck={setNewPasswordCheck}
                                passwordSubmit={passwordSubmit}
                            />
            //  updateNext={updateNext} 넘기는게 중요!!!
            default: return;
        }
    }

    return (
        <ProfileChange> 
            {/* <TitleTopbar title={"프로필 수정"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/> */}
            {
                renderPageController()  
            }
            <input style={{display:"none"}} type="file" id="imagePicker" name="imagePicker"  accept="image/png, image/jpeg" onChange={imageChange}/>
            <BottomModalVar2
                data={data}
                cancle={true}
                show={modalShow}    //모달 보여지는 여부
                setModalShow={setModalShow}
            />
            <TopModalbar 
                setShowModalTop={setShowModalTop}
                showModalTop={showModalTop}
                top={"calc(100vw*(51/375))"} text={"프로필 이미지가 변경되었습니다!"}
            />
            <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
        </ProfileChange>


    )
}


const ProfileChange = styled.div`
    padding : calc(100vw*(51/375)) 0 calc(100vw*(110/375)) 0;
`

